// window.parent.br2nl = function (str, replaceMode) {

//   var replaceStr = (replaceMode) ? "\n" : '';
//   // Includes <br>, <BR>, <br />, </br>
//   return str.replace(/<\s*\/?br\s*[\/]?>/gi, replaceStr);
// }


const script = (body) => `
<link href="https://cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet">
<script src="https://cdn.quilljs.com/1.3.6/quill.js"></script>
<script>
var Quill = window.Quill
var style = {
  title_text: {
		color: "black",
		fontFamily: "sans-serif",
		fontSize: "28px",
		fontWeight: "300",
		lineHeight: "42px",
	},
  subject_text: {
		color: "black",
		fontFamily: "sans-serif",
		fontSize: "32px",
		fontWeight: "600",
		lineHeight: "42px",
  },
  subtitle_text: {
		fontFamily: "ralewayregular, Arial,sans-serif",
		fontSize: "24px",
		fontWeight: "normal",
		lineHeight: "42px"
	},
	schedule_text: {
		fontFamily: "ralewayregular, Arial,sans-serif",
		fontSize: "16px",
		fontWeight: "normal",
		lineHeight: "30px"
	},
	confirmation_text: {
		fontFamily: "ralewayregular, Arial,sans-serif",
		fontStyle: "normal",
		fontWeight: "normal",
		fontSize: "18px",
		lineHeight: "150%",
		letterSpacing: "0.25px"
  }
}


var imageContainer = document.getElementsByClassName("image-banner"); 
if(imageContainer.length==0){
  imageContainer=document.getElementsByClassName("feature-image");
}
var loader = document.createElement("div");
var spinner = document.createElement("div");
spinner.className = "spinner"

  loader.style.position = "absolute";
  loader.style.top = "0";
  loader.style.left = "0";
  loader.style.right = "0";
  loader.style.height = "340px";
  loader.style.background = "white";
  loader.style.zIndex = -1;
  loader.style.display = "flex";
  loader.style.alignItems = "center";
  loader.style.justifyContent = "center";
  loader.appendChild(spinner)

if(imageContainer[0]){
  imageContainer[0].appendChild(loader);
  var cover = document.createElement("div");
  var imagePickerContainer = document.createElement("label");
  imagePickerContainer.innerHTML = "Change Image"
  imagePickerContainer.className = "image-picker"
  cover.className="image-cover"
  cover.appendChild(imagePickerContainer)
  imageContainer[0].appendChild(cover)
  imagePickerContainer.onclick=window.parent.onEmailBannerChange;
  try {
      window.parent.afterImageChange = function(url){
      var imgElement = document.querySelector('img[alt="Feature Image"]') ||  document.querySelector('img[alt="banner"]')
      loader.style.zIndex = 1;
      if(imgElement)imgElement.src = url;
      imgElement.onload = () => {
        loader.style.zIndex = -1;
      }
      window.parent.emailEditorInputChange("thankyou","image_url", url)
    }
  }catch(err){
    console.log("Errors:", err);
  }
}

var toolbar, hylyEditor, focusLock = false;
var boldIcon = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\
<path d="M10.5 9H16.5C17.2956 9 18.0587 9.34038 18.6213 9.94627C19.1839 10.5522 19.5 11.3739 19.5 12.2308C19.5 13.0876 19.1839 13.9094 18.6213 14.5153C18.0587 15.1212 17.2956 15.4615 16.5 15.4615H12.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M12.5 15.4614H18C18.9283 15.4614 19.8185 15.8585 20.4749 16.5654C21.1313 17.2723 21.5 18.231 21.5 19.2307V19.2307C21.5 20.2303 21.1313 21.189 20.4749 21.8959C19.8185 22.6028 18.9283 22.9999 18 22.9999H10.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M12.5 9V23" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
</svg>',

italicIcon = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\
<path d="M14.5 8.5H20.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M11.5 23.5H17.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M17.5 8.5L14.5 23.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
</svg>',

underlineIcon = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\
<path d="M8.5 23.5H23.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M20.5 9.5V16C20.5 17.1935 20.0259 18.3381 19.182 19.182C18.3381 20.0259 17.1935 20.5 16 20.5V20.5C14.8065 20.5 13.6619 20.0259 12.818 19.182C11.9741 18.3381 11.5 17.1935 11.5 16V9.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M9.5 9.5H13.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M18.5 9.5H22.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
</svg>',

formatIcon = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\
<path d="M9.5 10.5V8.5H23.5V10.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M16.5 19V23.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M16.5 8.5V14" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M13.5 23.5H19.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M12.5 12.5L20.9853 20.9853" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
</svg>',

numberIcon = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\
<path d="M14.5005 10.4998H23.5005" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M14.5005 16.4998H23.5005" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M14.5005 22.4998H23.5005" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M11.0504 11.8848H10.0714V9.99985C10.0714 9.77051 10.0761 9.56051 10.0854 9.36985C10.0166 9.45197 9.9417 9.52885 9.86143 9.59985L9.46143 9.93385L8.96143 9.31885L10.1874 8.31885H11.0504V11.8848Z" fill="#333333"/>\
<path d="M11.4894 17.9109H8.90035V17.2759L9.77235 16.3939C10.0214 16.1339 10.1834 15.9559 10.2604 15.8609C10.3236 15.7861 10.3773 15.7038 10.4204 15.6159C10.4499 15.5477 10.4648 15.4741 10.4644 15.3999C10.4663 15.3588 10.4593 15.3179 10.4438 15.2799C10.4282 15.2419 10.4045 15.2077 10.3744 15.1799C10.3026 15.1225 10.212 15.094 10.1204 15.0999C9.99988 15.1027 9.88228 15.1372 9.77935 15.1999C9.64061 15.2814 9.51031 15.3766 9.39035 15.4839L8.86035 14.8639C9.00263 14.7307 9.1581 14.6125 9.32435 14.5109C9.4526 14.4391 9.58979 14.3846 9.73235 14.3489C9.89595 14.3089 10.0639 14.2897 10.2324 14.2919C10.4454 14.2884 10.6568 14.3303 10.8524 14.4149C11.0235 14.488 11.1699 14.6088 11.2744 14.7629C11.3738 14.9127 11.426 15.089 11.4244 15.2689C11.4255 15.4004 11.4076 15.5314 11.3714 15.6579C11.3338 15.7815 11.2793 15.8993 11.2094 16.0079C11.1242 16.1382 11.0264 16.2598 10.9174 16.3709C10.796 16.4975 10.5377 16.7382 10.1424 17.0929V17.1179H11.4924L11.4894 17.9109Z" fill="#333333"/>\
<path d="M11.3704 21.1558C11.3755 21.3642 11.3044 21.5672 11.1704 21.7268C11.0138 21.8977 10.8098 22.0178 10.5844 22.0718V22.0858C11.1804 22.1605 11.4784 22.4425 11.4784 22.9318C11.4834 23.085 11.4498 23.2369 11.3808 23.3737C11.3118 23.5106 11.2095 23.6278 11.0834 23.7148C10.7566 23.9232 10.3723 24.0229 9.98539 23.9998C9.8069 24.0007 9.62864 23.987 9.45239 23.9588C9.27075 23.9265 9.09284 23.8759 8.92139 23.8078V23.0078C9.07277 23.0856 9.2329 23.1451 9.39839 23.1848C9.54495 23.2214 9.69533 23.2406 9.84639 23.2418C10.0058 23.2528 10.1654 23.2221 10.3094 23.1528C10.357 23.1243 10.3958 23.0831 10.4214 23.0339C10.447 22.9846 10.4584 22.9292 10.4544 22.8738C10.4599 22.7911 10.4326 22.7096 10.3784 22.6468C10.3096 22.5854 10.2251 22.5442 10.1344 22.5278C9.99009 22.4975 9.8428 22.4837 9.69539 22.4868H9.47539V21.7628H9.70039C10.1894 21.7628 10.4354 21.6378 10.4354 21.3868C10.4378 21.3453 10.429 21.3038 10.4098 21.2668C10.3906 21.2299 10.3618 21.1988 10.3264 21.1768C10.2373 21.1273 10.1362 21.1034 10.0344 21.1078C9.78135 21.1158 9.53581 21.1956 9.32639 21.3378L8.92639 20.6928C9.10291 20.5685 9.29893 20.4746 9.50639 20.4148C9.72826 20.3566 9.95701 20.3286 10.1864 20.3318C10.4917 20.3149 10.7949 20.3916 11.0554 20.5518C11.155 20.6174 11.2362 20.7072 11.2913 20.8129C11.3464 20.9186 11.3737 21.0367 11.3704 21.1558Z" fill="#333333"/>\
</svg>',

bulletIcon = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\
<path d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M10 17.5C10.8284 17.5 11.5 16.8284 11.5 16C11.5 15.1716 10.8284 14.5 10 14.5C9.17157 14.5 8.5 15.1716 8.5 16C8.5 16.8284 9.17157 17.5 10 17.5Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M10 23.5C10.8284 23.5 11.5 22.8284 11.5 22C11.5 21.1716 10.8284 20.5 10 20.5C9.17157 20.5 8.5 21.1716 8.5 22C8.5 22.8284 9.17157 23.5 10 23.5Z" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M14.5 10.5H23.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M14.5 16.5H23.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
<path d="M14.5 22.5H23.5" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/>\
</svg>'


function initEditor(){
  var wrapper = document.createElement('div');
  wrapper.id="main-wrapper-class"
  wrapper.className = "rich-text-Editor";
  wrapper.style.display = "flex";
  wrapper.style.flexDirection = "column-reverse";
  wrapper.style.marginBottom = "20px";

  var editor = document.getElementById("editor");
  editor.innerHTML="${body}"

  var parent = editor.parentNode;
  parent.replaceChild(wrapper, editor);
  wrapper.appendChild(editor);

 var toolbarOptions = ['bold', 'italic', 'underline', 'divider', { 'list': 'ordered' }, { 'list': 'bullet' }, 'divider', 'clean'];
 var icons = window.Quill.import('ui/icons');
 icons['bold'] = boldIcon;
  icons['italic'] = italicIcon;
  icons['underline'] = underlineIcon;
  icons['list']['bullet'] = bulletIcon;
  icons['list']['ordered'] = numberIcon;
  icons['clean'] = formatIcon;
   
    
  hylyEditor = new window.Quill('#editor', {
      theme: 'snow',
      modules: {
        toolbar: toolbarOptions// '#toolbar'
      }
  });
    document.getElementById("editor").style.border = "none";
      focusLock = true;
      let toolbar = document.getElementsByClassName("ql-toolbar")[0];
      if (toolbar) {
        toolbar.style.border = "none";
        toolbar.style.borderTop = "1px solid #dadada";
      }
  addTooltips();
  addListeners();
}

  const addTooltips = () => {
    let toolbar = document.getElementsByClassName('ql-toolbar');
    let tooltips = ["Bold", "Italic", "Underline", false,  "Numbered List","Bulleted List", false, "Remove Formating"]
    if (toolbar[0]) {
      for (let i = 0; i < toolbar[0].children[0].children.length; i++) {
        let tltp = document.createElement("span");
        tltp.innerHTML = tooltips[i];
        tltp.className = "editor-tooltip"
        toolbar[0].children[0].children[i].appendChild(tltp);
      }
    }
  }

  const addListeners = () => {

    toolbar = document.getElementsByClassName("ql-toolbar")[0]
    toolbar.addEventListener('focusin', e => {
      focusLock = true;
    });
    toolbar.addEventListener('focusout', e => {
      setTimeout(() => {
        focusLock = false;
      }, 100)
    });

    document.getElementById("editor").firstChild.onblur = () => {
      setTimeout(() => {
        if (!focusLock) {
          toggleToolbar()
        }
      }, 100)
      document.getElementById("main-wrapper-class").className="rich-text-Editor"
      var html = hylyEditor.root.innerHTML;
      window.parent.emailEditorInputChange("thankyou","confirmation_text", html)
    }

    document.getElementById("editor").firstChild.onfocus = () => {
       document.getElementById("main-wrapper-class").className="rich-text-Editor-focus"
      toggleToolbar(true)
    }
  }

function toggleToolbar(show){
  return;
   toolbar = document.getElementsByClassName("ql-toolbar")[0]
   toolbar.style.display = show ? "block" : "none";
   toolbar.style.borderTop = "none";
   toolbar.style.texAlign = "left";
}

initEditor();

function edit(ele, ignoreFocus) {
    let child = ele.firstChild.localName;
    if(child !== "input" && child !== "textarea"){
      var istextArea;
      var fieldName = "";
      for(let key in  ele.attributes){
        var hylyEdit = ele.attributes[key].nodeName && ele.attributes[key].nodeName.replace('-', '') === "hylyedit";
        if(ele.attributes[key].nodeValue === "confirmation_text" &&  hylyEdit){
          istextArea = true;
        }
        if(hylyEdit) fieldName = ele.attributes[key].nodeValue
      }

      if(ele){
        ele.className="hy-event-field"
      }

      if(ele.className.includes("event-message-body")){
        fieldName = "confirmation_text"
        istextArea = true;
      }

          
      var fields = ['confirmation_text','subject_text','title_text','subtitle_text'];
      if(fields.indexOf(fieldName) === -1)return;
      var value =  ele.innerHTML;
      var input = document.createElement(istextArea ? "textarea" : "input");
      input.className = "editable-input"
      input.value = istextArea ? window.parent.br2nl(String(value).trim(), true) : String(value).trim();
      //input.setSelectionRange(0,0)
      input.style = style[fieldName]
      input.style.fontSize = style[fieldName].fontSize;
      input.style.fontFamily = style[fieldName].fontFamily;
      input.style.color = ele.style.color;
      input.style.fontWeight = style[fieldName].fontWeight;
      input.style.lineHeight = style[fieldName].lineHeight;

      //input.style.fontSize = ele.style.fontSize;
      // input.style.fontFamily = ele.style.fontFamily;
      // input.style.color = ele.style.color;
      // input.style.fontWeight = ele.style.fontWeight;
      // input.style.lineHeight = ele.style.lineHeight;
      input.style.textAlign = istextArea ? "left" : "center"
      input.style.border = "none"
      input.style.width = "calc(100% - 10px)"
      //input.style.height = "100%"
      input.style.overflow = "hidden"
      input.resis
      ele.padding = 0;
      ele.innerHTML = ""
      ele.appendChild(input);
      if(!ignoreFocus)
      input.focus();
      input.onchange = (evt) => {
        console.log("j")
        if(window.parent.emailEditorInputChange){
            console.log("k")
          window.parent.emailEditorInputChange("thankyou",fieldName, evt.target.value)
        }
        else{
          console.log("callback not found")
        }
      }
      if(istextArea){
        input.style.height = input.scrollHeight + 'px'
        function autoResize() {
            this.style.height = 'auto';
            this.style.height = this.scrollHeight + 'px';
        }
        input.addEventListener('input', autoResize, false);
      }
    }
  }



  

</script>`

const style = (orgColors) => ` 
    .rich-text-Editor{
      border:1px solid #dadada;
    }

  .title_text{
    border: 1px solid #dadada;
  }
  .title_text:hover {
    border: 1px solid #26bbed;
    border-radius: 2px;
  }

    .title_text:hover::after {
    font:normal normal normal 1em/1 "Nucleo";
    content:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAjCAMAAACw/5reAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAORQTFRF/////f391tbWxsbG4ODg9vb2nZ2dh4eHmZmZhYWFsbGx9PT0mJiYnp6e8/Pz7Ozsk5OTqKio+/v7lpaWn5+f+vr68fHxlJSUpqam/Pz88vLylZWVgoKC5ubm7+/vjo6OtLS0m5ubkZGR7u7u39/fg4OD+Pj4+fn5nJycvb299/f3ycnJ4eHhxcXF2NjYhISE1dXV09PT9fX11NTU0tLSl5eX0dHR0NDQz8/Pmpqazs7Orq6uzc3NkpKSzMzMy8vL3t7eysrKkJCQp6enyMjIvLy85+fni4uLiYmJrKyso6Ojt7e3ZvbLQQAAAQRJREFUeJzN0m1XgjAUwPFrijFBLVGxWCnVRMEiDdFMMdOev//3iYOKd2y97XTf7L/ze7PtDODvJneUL/xmSvFYJaWc1DS9XIHqyWlNYhWj3oiXptk6E+zcohdJXLY7otn1q+skb1jGmmax6+zUoaIBdHuJ9tsSA3DtWD0y4K3nbivWW3LHncW03X27ln/P3c9SlXQzJLwZ6gjZAzbN0A8WkCG20RhZ6POmI5v4ATZFRTb1Q84ekc3YBBs8jQ82Z1POYOGlGbEZbwpNP8ySzXmDZ7p/mRWLMgb5l114dJk1KK2364auBIPyK9Tegn6LeqLB+8Ji9MP+DCXmfH1HBU0C/3B+AOI+GZjsg2z9AAAAAElFTkSuQmCC"); 
    position:absolute;
    top:0px;
    right:20px;
    width:20px;
    height:20px;
    transform: scale(.8);
  }

    .rich-text-Editor:hover{
      border:1px solid #26bbed;
    }
    .rich-text-Editor-focus{
      border:1px solid #999999;
    }
    .hy-event-field{
      border:1px solid #dadada;
      margin-bottom:16px;
      font-size:24px;
    }
    .hy-event-field:hover{
      border:1px solid #26bbed;
    }
    .ql-toolbar{
      text-align:left;
    }
    .ql-divider{
      width: 0 !important;
      border-left: 1px solid #cccccc !important;
      padding: 0 !important;
      margin-left: 10px !important;
    }
    .ql-snow.ql-toolbar button, .ql-snow .ql-toolbar button{
      padding: 0 !important;
      position: relative!important;
    }

    .ql-toolbar button:hover svg{
      stroke: #27bbed !important;
    }
    .ql-toolbar button:hover svg path{
      stroke: #27bbed !important;
    }

    .ql-active {
    background: #ebf7fe !important;
    }

    .ql-toolbar .editor-tooltip{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom:-50px;
      background: black;
      color: white;
      width:fit-content;
      white-space:nowrap;
      display: none;
      padding:10px;
      font-size: 14px;
    }

    .ql-toolbar .editor-tooltip::after {
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent black transparent;
    }

    .ql-toolbar button:hover .editor-tooltip{
      display:block;
    }

    

  table{
    background:white!important;
  }

  .feature-image{
    position:relative;
    max-width:600px;
    width:100%;
    max-height:340px;
  }
  .image-banner{
    position:relative;
    max-width:600px;
    width:100%;
    max-height:340px;
    margin-bottom:20px;
  }
  .image-cover{
    display:none;
  }
  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    margin-bottom:0px !important; 
  }
  .rich-text-Editor{
    margin-bottom:36px !important;
  }
  .rich-text-Editor-focus{
    margin-bottom:36px !important;
  }
  .feature-image:hover .image-cover{
    display: flex !important;
    justify-content: center;
    align-content: center;
    align-items: center;
    position: absolute;
    top:0;
    right:0;
    left:0;
    bottom:0;
    background:#f9f9f9e3;
  }
  .image-banner:hover .image-cover{
    display: flex !important;
    justify-content: center;
    align-content: center;
    align-items: center;
    position: absolute;
    top:0;
    right:0;
    left:0;
    bottom:0;
    background:#f9f9f9e3;
  }

  input[type="file"] {
    display: none;
  }

  .image-picker{
    color: ${orgColors ? orgColors.buttonFontColor : 'white'} !important;
    height: 40px;
    position: relative;
    background: ${orgColors ? orgColors.buttonBackgroundColor : '#26BBED'} !important;
    text-align: center;
    width:200px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-color:${orgColors ? orgColors.buttonBorderColor : '#26BBED'} !important;
    cursor:pointer;
  }

  td{
    position:relative;
  }

  input:focus{
    outline:none;
  }
  textarea{
    resize:none;
  }
  textarea:focus{
    outline:none;
  }
   .subject_text{
    border: 1px solid #dadada;
    position:relative;
    line-height:44px !important;
  }

  .ql-editor {
    font-size: 16px;
   }

    .subject_text:hover {
    border: 1px solid #26bbed;
    border-radius: 2px;
   line-height:44px !important;
  }


  .n-title {
    position:relative;
    font-size:24px !important;
    margin-bottom:16px !important;
    line-height:42px !important;
  }

  .subject_text:hover::after {
    font:normal normal normal 1em/1 "Nucleo";
    content:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAjCAMAAACw/5reAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAORQTFRF/////f391tbWxsbG4ODg9vb2nZ2dh4eHmZmZhYWFsbGx9PT0mJiYnp6e8/Pz7Ozsk5OTqKio+/v7lpaWn5+f+vr68fHxlJSUpqam/Pz88vLylZWVgoKC5ubm7+/vjo6OtLS0m5ubkZGR7u7u39/fg4OD+Pj4+fn5nJycvb299/f3ycnJ4eHhxcXF2NjYhISE1dXV09PT9fX11NTU0tLSl5eX0dHR0NDQz8/Pmpqazs7Orq6uzc3NkpKSzMzMy8vL3t7eysrKkJCQp6enyMjIvLy85+fni4uLiYmJrKyso6Ojt7e3ZvbLQQAAAQRJREFUeJzN0m1XgjAUwPFrijFBLVGxWCnVRMEiDdFMMdOev//3iYOKd2y97XTf7L/ze7PtDODvJneUL/xmSvFYJaWc1DS9XIHqyWlNYhWj3oiXptk6E+zcohdJXLY7otn1q+skb1jGmmax6+zUoaIBdHuJ9tsSA3DtWD0y4K3nbivWW3LHncW03X27ln/P3c9SlXQzJLwZ6gjZAzbN0A8WkCG20RhZ6POmI5v4ATZFRTb1Q84ekc3YBBs8jQ82Z1POYOGlGbEZbwpNP8ySzXmDZ7p/mRWLMgb5l114dJk1KK2364auBIPyK9Tegn6LeqLB+8Ji9MP+DCXmfH1HBU0C/3B+AOI+GZjsg2z9AAAAAElFTkSuQmCC"); 
    position:absolute;
    top:0px;
    right:20px;
    width:20px;
    height:20px;
    transform: scale(.8);
  }

   .subtitle_text{
    border: 1px solid #dadada;
    line-height:44px !important;
  }
  .subtitle_text:hover{
    border: 1px solid #26bbed;
    border-radius: 2px;
    line-height:44px !important;
  }

  .schedule_text:hover{
    border: 1px solid #EEEEEE;
    border-radius: 2px;
  }

  .event-message-title:hover{
    border: 1px solid #EEEEEE;
    border-radius: 2px;
  }

  .event-message-title:hover::after {
    font:normal normal normal 1em/1 "Nucleo";
    content:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAjCAMAAACw/5reAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAORQTFRF/////f391tbWxsbG4ODg9vb2nZ2dh4eHmZmZhYWFsbGx9PT0mJiYnp6e8/Pz7Ozsk5OTqKio+/v7lpaWn5+f+vr68fHxlJSUpqam/Pz88vLylZWVgoKC5ubm7+/vjo6OtLS0m5ubkZGR7u7u39/fg4OD+Pj4+fn5nJycvb299/f3ycnJ4eHhxcXF2NjYhISE1dXV09PT9fX11NTU0tLSl5eX0dHR0NDQz8/Pmpqazs7Orq6uzc3NkpKSzMzMy8vL3t7eysrKkJCQp6enyMjIvLy85+fni4uLiYmJrKyso6Ojt7e3ZvbLQQAAAQRJREFUeJzN0m1XgjAUwPFrijFBLVGxWCnVRMEiDdFMMdOev//3iYOKd2y97XTf7L/ze7PtDODvJneUL/xmSvFYJaWc1DS9XIHqyWlNYhWj3oiXptk6E+zcohdJXLY7otn1q+skb1jGmmax6+zUoaIBdHuJ9tsSA3DtWD0y4K3nbivWW3LHncW03X27ln/P3c9SlXQzJLwZ6gjZAzbN0A8WkCG20RhZ6POmI5v4ATZFRTb1Q84ekc3YBBs8jQ82Z1POYOGlGbEZbwpNP8ySzXmDZ7p/mRWLMgb5l114dJk1KK2364auBIPyK9Tegn6LeqLB+8Ji9MP+DCXmfH1HBU0C/3B+AOI+GZjsg2z9AAAAAElFTkSuQmCC"); 
    position:absolute;
    top:20px;
    right:20px;
    transform: scale(.8);
  }

  .event-message-body:hover{
    border: 1px solid #EEEEEE;
    border-radius: 2px;
  }

  .event-message-body:hover::after {
    font:normal normal normal 1em/1 "Nucleo";
    content:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAjCAMAAACw/5reAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAORQTFRF/////f391tbWxsbG4ODg9vb2nZ2dh4eHmZmZhYWFsbGx9PT0mJiYnp6e8/Pz7Ozsk5OTqKio+/v7lpaWn5+f+vr68fHxlJSUpqam/Pz88vLylZWVgoKC5ubm7+/vjo6OtLS0m5ubkZGR7u7u39/fg4OD+Pj4+fn5nJycvb299/f3ycnJ4eHhxcXF2NjYhISE1dXV09PT9fX11NTU0tLSl5eX0dHR0NDQz8/Pmpqazs7Orq6uzc3NkpKSzMzMy8vL3t7eysrKkJCQp6enyMjIvLy85+fni4uLiYmJrKyso6Ojt7e3ZvbLQQAAAQRJREFUeJzN0m1XgjAUwPFrijFBLVGxWCnVRMEiDdFMMdOev//3iYOKd2y97XTf7L/ze7PtDODvJneUL/xmSvFYJaWc1DS9XIHqyWlNYhWj3oiXptk6E+zcohdJXLY7otn1q+skb1jGmmax6+zUoaIBdHuJ9tsSA3DtWD0y4K3nbivWW3LHncW03X27ln/P3c9SlXQzJLwZ6gjZAzbN0A8WkCG20RhZ6POmI5v4ATZFRTb1Q84ekc3YBBs8jQ82Z1POYOGlGbEZbwpNP8ySzXmDZ7p/mRWLMgb5l114dJk1KK2364auBIPyK9Tegn6LeqLB+8Ji9MP+DCXmfH1HBU0C/3B+AOI+GZjsg2z9AAAAAElFTkSuQmCC"); 
    position:absolute;
    top:20px;
    right:20px;
    transform: scale(.8);
  }

  .n-subtitle {
     position:relative;
     margin-bottom:16px !important;
     font-size:24px !important;
  }

  .ql-snow a {
    color: #26bbed !important;
    text-decoration:none !important;
   }

  .schedule_text:hover::after {
    font:normal normal normal 1em/1 "Nucleo";
    content:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAjCAMAAACw/5reAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAORQTFRF/////f391tbWxsbG4ODg9vb2nZ2dh4eHmZmZhYWFsbGx9PT0mJiYnp6e8/Pz7Ozsk5OTqKio+/v7lpaWn5+f+vr68fHxlJSUpqam/Pz88vLylZWVgoKC5ubm7+/vjo6OtLS0m5ubkZGR7u7u39/fg4OD+Pj4+fn5nJycvb299/f3ycnJ4eHhxcXF2NjYhISE1dXV09PT9fX11NTU0tLSl5eX0dHR0NDQz8/Pmpqazs7Orq6uzc3NkpKSzMzMy8vL3t7eysrKkJCQp6enyMjIvLy85+fni4uLiYmJrKyso6Ojt7e3ZvbLQQAAAQRJREFUeJzN0m1XgjAUwPFrijFBLVGxWCnVRMEiDdFMMdOev//3iYOKd2y97XTf7L/ze7PtDODvJneUL/xmSvFYJaWc1DS9XIHqyWlNYhWj3oiXptk6E+zcohdJXLY7otn1q+skb1jGmmax6+zUoaIBdHuJ9tsSA3DtWD0y4K3nbivWW3LHncW03X27ln/P3c9SlXQzJLwZ6gjZAzbN0A8WkCG20RhZ6POmI5v4ATZFRTb1Q84ekc3YBBs8jQ82Z1POYOGlGbEZbwpNP8ySzXmDZ7p/mRWLMgb5l114dJk1KK2364auBIPyK9Tegn6LeqLB+8Ji9MP+DCXmfH1HBU0C/3B+AOI+GZjsg2z9AAAAAElFTkSuQmCC"); 
    position:absolute;
    top:0px;
    right:20px;
    transform: scale(.8);
  }


  .confirmation_text:hover{
    border: 1px solid #EEEEEE;
    border-radius: 2px;
  }

  .n-description {
     position:relative;
  }

  .subtitle_text:hover::after {
    font:normal normal normal 1em/1 "Nucleo";
    content:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAjCAMAAACw/5reAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAORQTFRF/////f391tbWxsbG4ODg9vb2nZ2dh4eHmZmZhYWFsbGx9PT0mJiYnp6e8/Pz7Ozsk5OTqKio+/v7lpaWn5+f+vr68fHxlJSUpqam/Pz88vLylZWVgoKC5ubm7+/vjo6OtLS0m5ubkZGR7u7u39/fg4OD+Pj4+fn5nJycvb299/f3ycnJ4eHhxcXF2NjYhISE1dXV09PT9fX11NTU0tLSl5eX0dHR0NDQz8/Pmpqazs7Orq6uzc3NkpKSzMzMy8vL3t7eysrKkJCQp6enyMjIvLy85+fni4uLiYmJrKyso6Ojt7e3ZvbLQQAAAQRJREFUeJzN0m1XgjAUwPFrijFBLVGxWCnVRMEiDdFMMdOev//3iYOKd2y97XTf7L/ze7PtDODvJneUL/xmSvFYJaWc1DS9XIHqyWlNYhWj3oiXptk6E+zcohdJXLY7otn1q+skb1jGmmax6+zUoaIBdHuJ9tsSA3DtWD0y4K3nbivWW3LHncW03X27ln/P3c9SlXQzJLwZ6gjZAzbN0A8WkCG20RhZ6POmI5v4ATZFRTb1Q84ekc3YBBs8jQ82Z1POYOGlGbEZbwpNP8ySzXmDZ7p/mRWLMgb5l114dJk1KK2364auBIPyK9Tegn6LeqLB+8Ji9MP+DCXmfH1HBU0C/3B+AOI+GZjsg2z9AAAAAElFTkSuQmCC"); 
    position:absolute;
    top:0px;
    right:20px;
    transform: scale(.8);
  }


  .confirmation-text:hover::after {
    font:normal normal normal 1em/1 "Nucleo";
    content:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAjCAMAAACw/5reAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAORQTFRF/////f391tbWxsbG4ODg9vb2nZ2dh4eHmZmZhYWFsbGx9PT0mJiYnp6e8/Pz7Ozsk5OTqKio+/v7lpaWn5+f+vr68fHxlJSUpqam/Pz88vLylZWVgoKC5ubm7+/vjo6OtLS0m5ubkZGR7u7u39/fg4OD+Pj4+fn5nJycvb299/f3ycnJ4eHhxcXF2NjYhISE1dXV09PT9fX11NTU0tLSl5eX0dHR0NDQz8/Pmpqazs7Orq6uzc3NkpKSzMzMy8vL3t7eysrKkJCQp6enyMjIvLy85+fni4uLiYmJrKyso6Ojt7e3ZvbLQQAAAQRJREFUeJzN0m1XgjAUwPFrijFBLVGxWCnVRMEiDdFMMdOev//3iYOKd2y97XTf7L/ze7PtDODvJneUL/xmSvFYJaWc1DS9XIHqyWlNYhWj3oiXptk6E+zcohdJXLY7otn1q+skb1jGmmax6+zUoaIBdHuJ9tsSA3DtWD0y4K3nbivWW3LHncW03X27ln/P3c9SlXQzJLwZ6gjZAzbN0A8WkCG20RhZ6POmI5v4ATZFRTb1Q84ekc3YBBs8jQ82Z1POYOGlGbEZbwpNP8ySzXmDZ7p/mRWLMgb5l114dJk1KK2364auBIPyK9Tegn6LeqLB+8Ji9MP+DCXmfH1HBU0C/3B+AOI+GZjsg2z9AAAAAElFTkSuQmCC"); 
    position:absolute;
    top:0px;
    right:20px;
    transform: scale(.8);
  }

  .spinner {
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #26bbed;
    width: 40px;
    height: 40px;
    -webkit-animation: spin 1s linear infinite; /* Safari */
    animation: spin 1s linear infinite;
  }
  .image-banner .n-event-banner{
    width: 600px !important;
    max-height: 340px !important;
    /* width: 80%; */
    margin: auto !important;

  }
  
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  }

 
 `

export const makeThankYouEmailTemplateEditable = (content, orgColors, body) => {
  if (!content) return ""
  content = content.replace(`hyly-edit="title_text"`, 'hyly-edit="title_text"  onclick="edit(this)"')
  content = content.replace(`hyly-edit="subject_text"`, 'hyly-edit="subject_text" onclick="edit(this)"')
  if (content.includes('class="event-message-title"') || content.includes('class="event-message-body"')) {
    content = content.replace(`class="event-message-title"`, 'class="event-message-title" onclick="edit(this)"')
    // content = content.replace(`class="event-message-body"`, 'class="event-message-body"')
    // content = content.replace(`class="confirmation_text"`, '')
  }
  else {
    content = content.replace(`hyly-edit="body_text"`, 'id="editor" hyly-edit="body_text"')
    content = content.replace(`hyly-edit="confirmation-text"`, 'id="editor" hyly-edit="confirmation_text"')
    content = content.replace(`hyly-edit="subtitle_text"`, 'hyly-edit="subtitle_text" onclick="edit(this)"')
  }


  content = content.replace("</html>", script(body) + " </html>")
  content = content.replace('<style type="text/css">', '<style type="text/css"> ' + style(orgColors))
  return content;
}
